import { EVERYONE_MENTION, FAMILY_LIMITS } from './constants.js';
// @mentions (M22, D27). A mention is `@` + a handle (lowercase letters,
// digits, underscore), not preceded by a word character, so emails
// ("me@example.com") and "@@" don't count.
const MENTION_PATTERN = new RegExp(`(^|[^A-Za-z0-9_@])@([a-z0-9_]{${FAMILY_LIMITS.MIN_HANDLE_LENGTH},${FAMILY_LIMITS.MAX_HANDLE_LENGTH}})(?![A-Za-z0-9_])`, 'g');
/** Distinct handles mentioned in `text`, in order of first appearance. */
export function extractMentionHandles(text) {
    const handles = [];
    for (const match of text.matchAll(MENTION_PATTERN)) {
        const handle = match[2];
        if (!handles.includes(handle))
            handles.push(handle);
    }
    return handles;
}
/** Whether `text` uses `@everyone` (M25, D43). */
export function mentionsEveryone(text) {
    return extractMentionHandles(text).includes(EVERYONE_MENTION);
}
/**
 * Splits `text` into plain and mention segments for rendering. Only handles
 * in `knownHandles` become mentions; anything else stays plain text.
 */
export function splitMentions(text, knownHandles) {
    const segments = [];
    let last = 0;
    for (const match of text.matchAll(MENTION_PATTERN)) {
        const handle = match[2];
        if (!knownHandles.has(handle))
            continue;
        const start = match.index + match[1].length;
        if (start > last)
            segments.push({ text: text.slice(last, start) });
        segments.push({ text: `@${handle}`, handle });
        last = start + handle.length + 1;
    }
    if (last < text.length)
        segments.push({ text: text.slice(last) });
    return segments;
}
//# sourceMappingURL=mentions.js.map